import { useState } from "react";
import { Delete, IdCard, TriangleAlert, X } from "lucide-react";
import { api } from "../../lib/api";
import { apiErrorMessage } from "../../lib/apiError";

const KEYS = ["1", "2", "3", "4", "5", "6", "7", "8", "9", "", "0", "back"];

/** «Chi sei?»: la persona dell'anagrafica reparti si riconosce col suo PIN di 4 cifre. */
export function PersonIdentityDialog({ people, withoutPin, onConfirm, onCancel }) {
  const [person, setPerson] = useState(null);
  const [pin, setPin] = useState("");
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const press = (key) => {
    setError("");
    if (key === "back") { setPin((current) => current.slice(0, -1)); return; }
    setPin((current) => (current.length >= 4 ? current : `${current}${key}`));
  };

  const confirm = async (code = pin) => {
    if (!person) return;
    if (code.length !== 4) { setError("Il PIN è di 4 cifre"); return; }
    setBusy(true);
    try {
      const { data } = await api.identifyShopfloorPerson({ person_key: person.key, pin: code });
      onConfirm(data);
    } catch (problem) {
      setError(apiErrorMessage(problem, "PIN non corretto"));
      setPin("");
    } finally {
      setBusy(false);
    }
  };

  const choose = (row) => {
    setError("");
    setPin("");
    setPerson(row);
  };

  return (
    <div className="material-modal" data-testid="person-identity-dialog">
      <div className="person-identity">
        <div className="wip-dialog-head">
          <div>
            <p className="eyebrow">CHI STA LAVORANDO</p>
            <h2>{person ? person.name : "Scegli il tuo nome"}</h2>
            <p>
              {person
                ? `${person.department_name || "reparto"} · digita il tuo PIN di 4 cifre`
                : "Il nome scelto finisce nelle timbrature, nei prelievi e negli storici"}
            </p>
          </div>
          <button className="icon-button" onClick={onCancel} aria-label="Chiudi" data-testid="person-identity-close"><X size={17} /></button>
        </div>

        {!person && (
          <div className="person-identity-list" data-testid="person-identity-list">
            {people.map((row) => (
              <button
                type="button"
                key={row.key}
                className={`person-identity-chip ${row.pin_set ? "" : "is-disabled"}`}
                disabled={!row.pin_set}
                onClick={() => choose(row)}
                data-testid={`person-identity-option-${row.key.replace(/\s+/g, "-")}`}
              >
                <b>{row.name}</b>
                <span>{[row.department_name, row.role].filter(Boolean).join(" · ") || "reparto"}</span>
                {!row.pin_set && (
                  <small>{row.has_account ? "Ha un account: entra col tuo accesso" : "PIN da impostare in Reparti e persone"}</small>
                )}
              </button>
            ))}
            {!people.length && <p className="empty-hint">Nessuna persona in anagrafica: aggiungila in Produzione → Reparti e persone.</p>}
          </div>
        )}

        {person && (
          <>
            <div className="person-identity-pin" data-testid="person-identity-pin">
              {[0, 1, 2, 3].map((slot) => <span key={slot} className={pin.length > slot ? "is-filled" : ""} />)}
            </div>
            <div className="person-identity-keys">
              {KEYS.map((key, index) => (key
                ? (
                  <button
                    type="button"
                    key={key}
                    disabled={busy}
                    onClick={() => press(key)}
                    data-testid={`person-identity-key-${key}`}
                  >
                    {key === "back" ? <Delete size={20} /> : key}
                  </button>
                )
                : <span key={`empty-${index}`} />))}
            </div>
          </>
        )}

        {error && <p className="quote-missing" data-testid="person-identity-error"><TriangleAlert size={15} /> {error}</p>}
        {!person && withoutPin?.length > 0 && (
          <p className="stamp-counts-hint" data-testid="person-identity-without-pin">
            Senza PIN: {withoutPin.join(", ")}. Chiedi all&apos;ufficio di impostarlo in Produzione → Reparti e persone.
          </p>
        )}

        <div className="part-workings-heading-actions">
          <button className="secondary-button" onClick={person ? () => { setPerson(null); setPin(""); } : onCancel} data-testid="person-identity-back">
            {person ? "Cambia persona" : "Annulla"}
          </button>
          {person && (
            <button className="primary-button" disabled={busy || pin.length !== 4} onClick={() => confirm()} data-testid="person-identity-confirm">
              <IdCard size={15} /> {busy ? "Verifica..." : "Confermo"}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
